import { render, staticRenderFns } from "./cpu.vue?vue&type=template&id=9804386c&scoped=true"
import script from "./cpu.vue?vue&type=script&lang=js"
export * from "./cpu.vue?vue&type=script&lang=js"
import style0 from "./cpu.vue?vue&type=style&index=0&id=9804386c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9804386c",
  null
  
)

export default component.exports